import type {
  UpdateRegistrationUserSSOApiQuery,
  RegisterB2bUserApiQuery,
  UpdateReassignUserApiQuery,
  UpdateEmailApiQuery,
} from "@/Modules/Models/Api/OnBoarding";

import { patch2, post2 } from "./utils/FunctionalTherapyApi";

export async function updateRegistrationUserSSO(
  updateRegistrationUserSSOApiQuery: UpdateRegistrationUserSSOApiQuery,
  uuid: string
): Promise<void> {
  return patch2<UpdateRegistrationUserSSOApiQuery, void>(
    `/v1.0/users/${uuid}/assignments`,
    updateRegistrationUserSSOApiQuery
  );
}

export async function registerB2bUser(b2bUserApiQuery: RegisterB2bUserApiQuery): Promise<void> {
  return post2<RegisterB2bUserApiQuery, void>("/v1.0/users/integration/b2b", b2bUserApiQuery);
}

export async function updateReassignUser(
  updateReassignUserApiQuery: UpdateReassignUserApiQuery,
  uuid: string
): Promise<void> {
  return patch2<UpdateReassignUserApiQuery, void>(`/v1.0/users/${uuid}/reassign`, updateReassignUserApiQuery);
}

export function updateEmail(updateEmailApiQuery: UpdateEmailApiQuery): Promise<void> {
  return post2<UpdateEmailApiQuery, void>("/v1.0/users/b2b/change_email", updateEmailApiQuery);
}
